"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MarketingIcon;
exports.propTypes = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _kebabCase = _interopRequireDefault(require("lodash/kebabCase"));
var _helpers = require("../../helpers");
const _excluded = ["children", "className", "label", "width", "height", "viewBox", "style"];
const DEFAULT_WIDTH = 68;
const DEFAULT_HEIGHT = 68;
function MarketingIcon(_ref) {
  let {
      children,
      className,
      label,
      viewBox,
      style
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
    viewBox: viewBox || `0 0 ${DEFAULT_WIDTH} ${DEFAULT_HEIGHT}` // default viewBox is 16x16. if you want a diff viewBox, you're on you're own
    ,
    role: "graphics-symbol",
    "aria-label": label,
    xmlns: "http://www.w3.org/2000/svg",
    className: (0, _helpers.classString)([className, `marketing-icon-${(0, _kebabCase.default)(label)}`]),
    style: style
  }, others), children);
}
const propTypes = exports.propTypes = {
  className: _propTypes.default.string,
  label: _propTypes.default.string,
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  viewBox: _propTypes.default.string
};
MarketingIcon.propTypes = Object.assign({
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
}, propTypes);